import React, { Component } from 'react';
import { Form} from 'semantic-ui-react';
import './styles.scss';
import { connect } from 'react-redux';
import { withTranslation } from "react-i18next";
import { compose } from 'redux';

class PositionForm extends Component {
    constructor() {
        super();
        this.state = {
            errInputMsg: {}
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            errInputMsg: nextProps.isError
        });
    }

    handleChangeInput = (evt) =>{
        this.props.changePosition(evt);
    }
    
    render() {
        const { positionData, t } = this.props;
        return (            
            <div className="employee-form">
                <Form>
                    <Form.Group inline className="form-required">
                        <label>{t('labels.positionCode')}</label>
                        <Form.Input name="positionCode" maxLength="12" 
                            value={positionData.positionCode} 
                            onChange={e => {this.handleChangeInput(e)}}
                        />
                    </Form.Group>
                    <div className="error-message form-list-message">{t(this.state.errInputMsg['positionCode'])}</div>
                    <Form.Group inline className="form-required">
                        <label>{t('labels.description')}</label>
                        <Form.Input name="positionName" 
                            value={positionData.positionName} 
                            onChange={e => {this.handleChangeInput(e)}}
                            maxLength="50"
                        />
                    </Form.Group>
                    <div className="error-message form-list-message">{t(this.state.errInputMsg['positionName'])}</div>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
})

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(PositionForm);
